import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { type BadgeColor } from './types';
import StatusBadge from './StatusBadge';

export type HttpCodeBadgeVariant = 'code' | 'label' | 'custom';
export type HttpCodeBadgeStyle = 'badge' | 'dot';

interface Props {
  code: number;
  color?: BadgeColor;
  variant?: HttpCodeBadgeVariant;
  customLabel?: string;
  style?: HttpCodeBadgeStyle;
}

export function parseHttpStatus(httpStatus: number) {
  let color: BadgeColor = 'muted';
  let label: string = '';
  if (httpStatus >= 200 && httpStatus < 300) {
    label = 'Success';
    color = 'success';
  } else if (httpStatus >= 300 && httpStatus < 400) {
    label = 'Redirect';
    color = 'info';
  } else {
    label = 'Error';
    color = 'danger';
  }
  return { label, color };
}

export default function HttpCodeBadge({
  code,
  color = 'muted',
  variant = 'code',
  customLabel = '',
  style = 'badge',
}: Props) {
  const { label: parsedLabel, color: parsedColor } =
    !color || !customLabel ? parseHttpStatus(code) : { label: customLabel, color };

  let displayText = '';
  switch (variant) {
    case 'code':
      displayText = code.toString();
      break;
    case 'label':
      displayText = parsedLabel;
      break;
    case 'custom':
      displayText = customLabel || code.toString(); // Fallback to code if no custom label
      break;
  }

  const displayColor = color ?? parsedColor;

  return style === 'dot' ? (
    <OverlayTrigger placement='top' overlay={<Tooltip>{displayText}</Tooltip>}>
      <span>
        <StatusBadge color={displayColor} />
      </span>
    </OverlayTrigger>
  ) : (
    <span className={`badge badge-light-${displayColor} text-capitalize align-middle`}>
      {displayText}
    </span>
  );
}
